<template>
  <div class="columns is-multiline mgb-0">
    <b-field :label="$t('popUpParametrageReseauTempoDispo.location')"
             class="obligatoire column is-6 mgb-0">
      <b-select v-model="parametrageSelection.produitLoc" expanded>
        <option v-for='produit in produitsLocation'
                :key="produit.id"
                :value="produit.id">
          {{ produit.libelle }}
          <span v-if="produit.reference"> - {{produit.reference}} </span>
        </option>
      </b-select>
    </b-field>
    <b-field :label="$t('popUpParametrageReseauTempoDispo.niveauDeDispo')"
             class="obligatoire column is-6 mgb-0">
      <b-select v-model="parametrageSelection.niveauDeDispo" expanded>
        <option v-for='niveau in NIVEAU_DISPONIBILITE'
                :key="niveau.key"
                :value="niveau.key">
          {{ $t(niveau.libelle) }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<script>

import { NIVEAU_DISPONIBILITE } from '@/configuration/optionBlocage/optionBlocage';

export default {
  props: {
    produitsLocation: {
      type: Array,
      required: true,
    },
    parametrageSelection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      NIVEAU_DISPONIBILITE: NIVEAU_DISPONIBILITE,
    };
  },
};

</script>

<style scoped>

</style>
